import { createSlice } from "@reduxjs/toolkit";
import { REHYDRATE } from "redux-persist";
import { AuthInitialState } from "./constants";

export const authReducer = createSlice({
  name: "auth",
  initialState: AuthInitialState,
  reducers: {
    authenticateUser: (state, action) => {
      const updatedState = {
        ...state,
        ...action.payload,
      };
      return updatedState;
    },
    getProfileDetails: (state, action) => {
      const updatedState = {
        ...state,
        ...action.payload,
      };
      return updatedState;
    },
    logoutUser: (state) => {
      return AuthInitialState;
    },
    [REHYDRATE]: (state, action) => {
      if (action.payload && action.payload.auth) {
        return {
          ...state,
          ...action.payload.auth, // Merge persisted auth state
        };
      } else {
        return state;
      }
    },
  },
});

export const { authenticateUser, getProfileDetails, logoutUser } =
  authReducer.actions;
export default authReducer.reducer;
